/* cm-shop.js (2026-10-14): behavior for the Shop page (sections/cm-shop.liquid).
   Reveal on scroll, collection tabs, marquee pause, and the catalog: filters (show, price, collection, brand),
   search, sorting (featured, price, name) and "show more". Without JavaScript every card is shown.
   Featured order follows the owner's brand rules: MegaMotion first for power chairs and scooters, Bruno first
   among installed products, Pride and Golden lead lift recliners, Vive leads walkers, manual wheelchairs and
   bathroom safety. It never uses sales figures. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cms]');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };

  /* ---------- reveal ---------- */
  if (!reduce && 'IntersectionObserver' in window) {
    var targets = $$('.cms-rv, .cms-stg');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('in'); else io.observe(el);
    });
    root.classList.add('is-anim');
  }

  /* ---------- collection tabs ---------- */
  var tabs = $$('[data-cms-tab]');
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      var d = t.getAttribute('data-cms-tab');
      tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
      $$('.cms-tile').forEach(function (tile) {
        var dept = tile.getAttribute('data-dept');
        tile.hidden = !(d === 'all' || dept === d || dept === 'both');
      });
    });
  });

  /* ---------- marquee pause ---------- */
  $$('[data-cms-mq-pause]').forEach(function (b) {
    var mq = b.parentNode.previousElementSibling;
    b.addEventListener('click', function () {
      var on = b.getAttribute('aria-pressed') !== 'true';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (mq) mq.classList.toggle('is-paused', on);
    });
  });

  /* ---------- catalog ---------- */
  var grid = $('[data-cms-grid]');
  if (!grid) return;
  var cards = $$('.cms-card', grid);
  var STEP = 24;
  var state = { show: 'all', pr: [], c: [], b: [], q: [], sort: 'featured', limit: STEP };

  cards.forEach(function (c) {
    var d = c.dataset;
    c._i = +d.i || 0;
    c._pr = +d.pr;
    c._po = +d.po || 99;
    c._img = d.img === '1';
    c._t = d.t || '';
    c._hay = (d.t + ' ' + (d.b || '').toLowerCase() + ' ' + (d.c || '').replace(/-/g, ' ')).toLowerCase();
  });

  function brandRank(c) {
    var b = c.dataset.b, p = c.dataset.p || '';
    if (b === 'MegaMotion') return 0;
    if (b === 'Bruno') return 0;
    if (b === 'Vive Health' && /^(walkers-rollators|walkers|rollators|wheelchairs|bathroom-safety)$/.test(p)) return 0;
    if (b === 'Harmar') return 1;
    if (b === 'Pride Mobility' || b === 'Golden Technologies') return 1;
    if (b === 'Vive Health') return 2;
    return 3;
  }
  // featured: products with a photo first, taking one from each product line in turn (lines in the store's
  // order); inside a line, the lead brand first, then the store's own order
  var featured = (function () {
    var groups = {}, keys = [];
    cards.forEach(function (c) {
      var k = (c._img ? '0' : '1') + '|' + (1000 + c._po) + '|' + (c.dataset.p || '');
      if (!groups[k]) { groups[k] = []; keys.push(k); }
      groups[k].push(c);
    });
    keys.sort();
    keys.forEach(function (k) { groups[k].sort(function (a, b) { return brandRank(a) - brandRank(b) || a._i - b._i; }); });
    var out = [];
    [true, false].forEach(function (withImg) {
      var ks = keys.filter(function (k) { return (k.charAt(0) === '0') === withImg; });
      var more = true;
      while (more) {
        more = false;
        ks.forEach(function (k) { if (groups[k].length) { out.push(groups[k].shift()); more = true; } });
      }
    });
    return out;
  })();

  function sorted() {
    if (state.sort === 'featured') return featured.slice();
    var list = cards.slice();
    if (state.sort === 'name') list.sort(function (a, b) { return a._t.localeCompare(b._t) || a._i - b._i; });
    else {
      var dir = state.sort === 'price-asc' ? 1 : -1;
      list.sort(function (a, b) {
        var pa = a._pr, pb = b._pr;
        if (pa < 0 && pb < 0) return a._i - b._i;
        if (pa < 0) return 1;
        if (pb < 0) return -1;
        return (pa - pb) * dir || a._i - b._i;
      });
    }
    return list;
  }

  function match(c) {
    var d = c.dataset;
    if (state.show === 'buy' && (d.q === '1' || c._pr < 0)) return false;
    if (state.show === 'quote' && d.q !== '1') return false;
    if (state.pr.length) {
      if (c._pr < 0) return false;
      var okp = state.pr.some(function (r) { var a = r.split('-'); return c._pr >= +a[0] && (a[1] === '' || c._pr < +a[1]); });
      if (!okp) return false;
    }
    if (state.c.length && !state.c.some(function (h) { return (d.c || '').indexOf(' ' + h + ' ') > -1; })) return false;
    if (state.b.length && state.b.indexOf(d.b) < 0) return false;
    if (state.q.length && !state.q.every(function (w) { return c._hay.indexOf(w) > -1; })) return false;
    return true;
  }

  var countEl = $('[data-cms-count]'), moreBtn = $('[data-cms-more]'), emptyEl = $('[data-cms-empty]'), activeEl = $('[data-cms-active]');
  var labelOf = {};
  $$('[data-cms-f]').forEach(function (i) { var s = i.parentNode.querySelector('span'); labelOf[i.getAttribute('data-cms-f') + ':' + i.value] = s ? s.textContent : i.value; });

  function render() {
    var list = sorted(), shown = 0, total = 0;
    var frag = document.createDocumentFragment();
    list.forEach(function (c) {
      var m = match(c);
      if (m) total++;
      var vis = m && shown < state.limit;
      if (vis) shown++;
      c.hidden = !vis;
      frag.appendChild(c);
    });
    grid.appendChild(frag);
    if (countEl) countEl.textContent = total + (total === 1 ? ' product' : ' products');
    if (moreBtn) {
      var left = total - shown;
      moreBtn.hidden = left <= 0;
      moreBtn.textContent = 'Show ' + Math.min(STEP, left) + ' more';
    }
    if (emptyEl) emptyEl.hidden = total > 0;
    renderActive();
  }

  function renderActive() {
    if (!activeEl) return;
    activeEl.innerHTML = '';
    var add = function (txt, fn) {
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = txt; b.setAttribute('aria-label', 'Remove filter: ' + txt);
      b.addEventListener('click', function () { fn(); syncInputs(); state.limit = STEP; render(); });
      activeEl.appendChild(b);
    };
    if (state.show !== 'all') add(state.show === 'buy' ? 'Buy online' : 'Quote', function () { state.show = 'all'; });
    ['pr', 'c', 'b'].forEach(function (k) {
      state[k].forEach(function (v) { add(labelOf[k + ':' + v] || v, function () { state[k] = state[k].filter(function (x) { return x !== v; }); }); });
    });
    if (state.q.length) add('"' + state.q.join(' ') + '"', function () { state.q = []; var s = document.getElementById('cms-q'); if (s) s.value = ''; });
  }

  function syncInputs() {
    $$('[data-cms-f]').forEach(function (i) { i.checked = state[i.getAttribute('data-cms-f')].indexOf(i.value) > -1; });
    $$('[data-cms-show]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cms-show') === state.show ? 'true' : 'false'); });
  }

  // filter counts (whole catalog); hide filters with nothing in them
  $$('[data-cms-n]').forEach(function (s) {
    var key = s.getAttribute('data-cms-n'), k = key.slice(0, 1), v = key.slice(2), n = 0;
    cards.forEach(function (c) {
      if (k === 'b' && c.dataset.b === v) n++;
      if (k === 'c' && (c.dataset.c || '').indexOf(' ' + v + ' ') > -1) n++;
    });
    s.textContent = n;
    if (!n) s.parentNode.hidden = true;
  });

  $$('[data-cms-f]').forEach(function (i) {
    i.addEventListener('change', function () {
      var k = i.getAttribute('data-cms-f');
      state[k] = state[k].filter(function (x) { return x !== i.value; });
      if (i.checked) state[k].push(i.value);
      state.limit = STEP; render();
    });
  });
  $$('[data-cms-show]').forEach(function (b) {
    b.addEventListener('click', function () { state.show = b.getAttribute('data-cms-show'); syncInputs(); state.limit = STEP; render(); });
  });
  $$('[data-cms-clear]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.show = 'all'; state.pr = []; state.c = []; state.b = []; state.q = [];
      var s = document.getElementById('cms-q'); if (s) s.value = '';
      syncInputs(); state.limit = STEP; render();
    });
  });
  var sortSel = $('[data-cms-sortsel]');
  if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; state.limit = STEP; render(); });
  if (moreBtn) moreBtn.addEventListener('click', function () { state.limit += STEP; render(); });

  var ft = $('[data-cms-ftoggle]'), fp = $('[data-cms-filters]');
  if (ft && fp) ft.addEventListener('click', function () {
    var open = !fp.classList.contains('is-open');
    fp.classList.toggle('is-open', open);
    ft.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  function goBrowse() {
    var t = document.getElementById('browse');
    if (!t) return;
    var hdr = document.querySelector('[data-header]');
    var y = t.getBoundingClientRect().top + window.pageYOffset - (hdr ? hdr.offsetHeight : 0) - 12;
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  }

  // hero search: filters the catalog in place (the form still works as a store search without JavaScript)
  var sf = $('[data-cms-search]');
  if (sf) {
    var si = document.getElementById('cms-q');
    var setQ = function () { state.q = (si.value || '').toLowerCase().split(/\s+/).filter(Boolean); state.limit = STEP; render(); };
    sf.addEventListener('submit', function (e) { e.preventDefault(); setQ(); goBrowse(); });
    si.addEventListener('input', function () { clearTimeout(si._t); si._t = setTimeout(setQ, 200); });
  }
  // chips and the spotlight button pick collections (capture phase, ahead of the theme's own #link scrolling)
  $$('[data-cms-chip]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      state.c = a.getAttribute('data-cms-chip').split(',');
      state.show = 'all'; state.limit = STEP;
      syncInputs(); render(); goBrowse();
    }, true);
  });

  render();
})();
